// extracted by mini-css-extract-plugin
export var quantityInput = "_j0-0";